import { stripMarkdown } from './utils/stripMarkdown'

export const MARKDOWN_FORMAT = 'markdown'

/*
 * Cross-app data contract reserved field names (NOT written by Happily-Company today
 * because no async translation flow exists here; included for documentation parity
 * with the React Native sibling app):
 *   `${prefix}_langs`     — { [lang]: plainTranslation }
 *   `${prefix}_md_langs`  — { [lang]: markdownTranslation }
 * If/when a Translate(text, lang) service is added, port walkText.ts and
 * translateMarkdownField from the sibling app.
 */

export const isMarkdown = (doc: any, prefix = 'description'): boolean =>
  !!(doc && doc[`${prefix}_format`] === MARKDOWN_FORMAT && doc[`${prefix}_md`])

export const markdownFields = (md: string, prefix = 'description'): { [k: string]: any } => {
  const source = md || ''
  return {
    [prefix]: stripMarkdown(source),
    [`${prefix}_md`]: source,
    [`${prefix}_format`]: MARKDOWN_FORMAT,
  }
}

export const initialEditorValue = (
  doc: any,
  prefix = 'description',
  languageFallback?: string,
): string => {
  if (!doc) return ''
  if (isMarkdown(doc, prefix)) return doc[`${prefix}_md`] || ''
  const raw = doc[prefix]
  if (raw && typeof raw === 'object') {
    return raw[languageFallback as string] || raw.en || Object.values(raw)[0] || ''
  }
  return raw || ''
}
